import { render, staticRenderFns } from "./TuijCompany.vue?vue&type=template&id=584d9f56&scoped=true&"
import script from "./TuijCompany.vue?vue&type=script&lang=js&"
export * from "./TuijCompany.vue?vue&type=script&lang=js&"
import style0 from "./TuijCompany.vue?vue&type=style&index=0&id=584d9f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d9f56",
  null
  
)

component.options.__file = "TuijCompany.vue"
export default component.exports